import { useEffect, useState } from "react";
import { getOfflineSnapshot, subscribeToOfflineStatus } from "../core/offline-status";

export function useOfflineStatus() {
  const [snapshot, setSnapshot] = useState(getOfflineSnapshot());

  useEffect(() => subscribeToOfflineStatus(setSnapshot), []);

  return snapshot;
}
